"use client";

import { createContext, useContext, useRef, type ReactNode } from "react";

interface HeroContextType {
  getNextHeroIndex: () => number;
}

const HeroContext = createContext<HeroContextType | undefined>(undefined);

export const HeroProvider = ({ children }: { children: ReactNode }) => {
  const heroCountRef = useRef(0);

  const getNextHeroIndex = () => {
    return heroCountRef.current++;
  };

  return (
    <HeroContext.Provider value={{ getNextHeroIndex }}>
      {children}
    </HeroContext.Provider>
  );
};

export const useHeroContext = () => {
  const context = useContext(HeroContext);
  if (context === undefined) {
    throw new Error("useHeroContext must be used within a HeroProvider");
  }
  return context;
};